import { Box, styled, TableCell } from '@mui/material';

export const TableCellStyledForInstallment = styled(TableCell)(({ theme }) => ({
  color: 'white',
  padding: '1rem 3rem',
  background: theme.palette.primary.dark,
  borderBottomColor: theme.palette.secondary.dark,
  whiteSpace: 'nowrap',
}));

export const TableCellGroupForInstallment = styled(TableCellStyledForInstallment)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const TableFooterBoxStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: '1rem',
  minHeight: '3.125rem',
  backgroundColor: theme.palette.primary.dark,
}));